import moment from 'moment'

import { StatisticValue, StatisticValueInfoFragment } from '@/generated/graphql'

export const getAllThreeWeekContinuousDownTrend = (array: StatisticValueInfoFragment[]) => {
  const res = []
  for (let i = 0; i < array.length; i++) {
    const start = array[i]
    const middle = array[i + 1]
    const end = array[i + 2]
    if (start && middle && end && start.value > middle.value && middle.value > end.value) {
      res.push({ start: [start.yearWeek, start.value], end: [end.yearWeek, end.value] })
    }
  }
  return res
}

export const compensateWeekData = (year: moment.Moment, array: StatisticValue[]) => {
  let weeks = year.weeksInYear()
  const currentWeek = moment().week()

  // 不显示未来日期
  if (moment().year() === year.year()) {
    weeks = currentWeek
  }

  return Array.from({ length: weeks }, (_x, index) => {
    const yearWeek = year
      .clone()
      .week(index + 1)
      .format('YYYY-WW')
    const item = array.find((item) => item.yearWeek === yearWeek)
    return item || { yearWeek, value: 0 }
  })
}
